import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import useRequestResetLinkMutation, {
  type RequestResetLinkValues,
} from './queries/useRequestResetLinkMutation';

const useForgotPasswordSubmit = () => {
  const { t } = useTranslation();
  const [errorMessage, setErrorMessage] = useState<string>();
  const [isRequestSent, setIsRequestSent] = useState<boolean>(false);
  const clearErrors = () => setErrorMessage(undefined);

  const mutation = useRequestResetLinkMutation({
    onSuccess: () => setIsRequestSent(true),
    onError: () =>
      setErrorMessage(t('pageForgotPassword.errorRequestResetLink')),
  });

  const handleSubmitForgotPassword = (values: RequestResetLinkValues) => {
    clearErrors();
    mutation.mutate(values);
  };

  return {
    clearErrors,
    errorMessage,
    handleSubmitForgotPassword,
    isRequestSent,
    isSubmitting: mutation.isPending,
  };
};

export default useForgotPasswordSubmit;
